export default function(events, $element, handler, eventListenerOptions) {
    for (const eventName of events) {
        $element.removeEventListener(eventName, handler, eventListenerOptions);
    }
}